import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-comment-history-modal',
  templateUrl: './comment-history-modal.component.html',
  styleUrls: ['./comment-history-modal.component.css']
})
export class CommentHistoryModalComponent implements OnInit {
  commentHistory: any;
  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    //console.log(this.commentHistory);
  }
  closehistoryModal() {
    this.bsModalRef.hide();
  }

}
